<template>
  <div class="wrap container">
    <!-- <div class="info_box">
      <div class="avatar">
        <el-image
          class="img"
          :src="
            studentInfo
              ? studentInfo.avatar
              : require('@/assets/images/icons/icon_me.png')
          "
          fit="cover"
        ></el-image>
      </div>
      <div class="right">
        <template v-if="studentInfo">
          <p class="name_row">
            <span>{{ studentInfo.name || studentInfo.username }}</span>
            <img
              v-if="studentInfo.sex == 'MAN'"
              class="icon sex_icon"
              src="@/assets/images/icons/icon_male.png"
              alt=""
            />
            <img
              v-if="studentInfo.sex == 'WOMAN'"
              class="icon sex_icon"
              src="@/assets/images/icons/icon_female.png"
              alt=""
            />
          </p>
          <p>
            <img
              class="icon"
              src="@/assets/images/icons/icon_school.png"
              alt=""
            />
            <span>{{ studentInfo.schoolName || "无" }}</span>
          </p>
          <p>
            <img
              class="icon"
              src="@/assets/images/icons/icon_major.png"
              alt=""
            />
            <span>{{ studentInfo.major || "无" }}</span>
            <span style="margin-left: 10px">{{ studentInfo.className }}</span>
          </p>
          <p>
            <img
              class="icon"
              src="@/assets/images/icons/icon_address.png"
              alt=""
            />
            <span>{{ studentInfo.sno || "无" }}</span>
          </p>
        </template>
        <el-button class="set_btn" @click="onClickJoin">加入班级</el-button>
        <img
          class="set_icon"
          src="@/assets/images/icons/icon_setting.png"
          @click="activeIdx = 2"
          alt=""
        />
      </div>
    </div> -->

    <div class="main">
      <!-- 班级课程列表 -->
      <template v-if="activeIdx == 0">
        <div class="class_box" v-if="!empty">
          <!-- <div class="title-row">
            <p class="title">我的课程</p>
            <el-checkbox v-model="sortClass" style="float: right"
              >手动排序</el-checkbox
            >
            <el-button
              type="primary"
              v-show="sortClass"
              style="float: right; margin-right: 15px"
              size="mini"
              @click="handleSort"
              >确定</el-button
            >
          </div> -->
          <vuedraggable
            class="vue-draggable"
            v-model="classList"
            :disabled="!sortClass"
            tag="ul"
            draggable=".draggable-item"
            animation="300"
            @start="onDragStart"
            @end="onDragEnd"
          >
            <!-- 拖拽元素 -->

            <li
              class="lesson draggable-item"
              v-for="item in classList"
              :key="item.id"
              @click="goDetail(item.classId)"
            >
              <div class="cover_box">
                <el-image class="cover" :src="item.icon" fit="cover"></el-image>
                <div class="mask">
                  <i
                    class="el-icon-delete"
                    @click="handleDel(item.classId)"
                  ></i>
                </div>
              </div>
              <div class="lesson_info">
                <p class="lesson_title">{{ item.courseTitle }}</p>
                <p class="class_name">{{ item.name }}</p>
                <!-- <div class="counts">
                  <div class="count_item">
                    <p>章节</p>
                    <p>{{ item.chapterCount || 0 }}</p>
                  </div>
                  <div class="count_item">
                    <p>团队</p>
                    <p>{{ item.teamCount || 0 }}</p>
                  </div>
                  <div class="count_item">
                    <p>学员数</p>
                    <p>{{ item.studentCount || 0 }}</p>
                  </div>
                  <div class="count_item" style="margin-right: 0">
                    <p>进度</p>
                    <p>{{ item.progress || 0 }}%</p>
                  </div>
                </div> -->
                <!-- <div class="bottom">
                  <el-button
                    class="btn"
                    type="primary"
                    @click="goDetail(item.classId)"
                    >上课</el-button
                  >
                </div> -->
              </div>
            </li>
          </vuedraggable>
        </div>
        <!-- 空状态 -->
        <empty-status
          desc="您还没加入班级，请先加入班级"
          buttonText="加入班级"
          haveButton
          @btnClick="onClickJoin"
          v-else
        />
      </template>

      <!-- 修改个人信息 -->
      <template v-else>
        <modify-info :studentInfo="studentInfo" @back="back" />
      </template>
    </div>

    <el-dialog class="code_dialog" :visible.sync="showCode" center width="35%">
      <img src="@/assets/images/logo_icon.png" alt="logo" class="logo" />
      <p class="tips">请输入您要加入的班级码</p>
      <el-input
        class="input"
        v-model="classCode"
        placeholder="请输入班级码"
      ></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button class="btn left" type="primary" @click="handleJoin"
          >确 定</el-button
        >
        <el-button class="btn" @click="showCode = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showTips" width="30%" center>
      <p style="text-align: center">请在上课前先完善个人信息</p>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            activeIdx = 1;
            showTips = false;
          "
          >去完善</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import { classList, joinClass, delClass, sortClass } from "@/api/class";
import emptyStatus from "@/components/emptyStatus/index";
import modifyInfo from "./modifyInfo";
export default {
  components: {
    vuedraggable,
    emptyStatus,
    modifyInfo,
  },
  data() {
    return {
      activeIdx: 0,
      classList: [],
      empty: false,
      classCode: "",
      showCode: false,
      sortClass: false,
      showTips: false,
    };
  },
  created() {
    this.getClassList();
  },
  computed: {
    studentInfo() {
      return this.$store.state.myInfo;
    },
  },
  methods: {
    // 班级列表
    getClassList() {
      this.$loading.show();
      classList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classList = res.data;
          this.empty = res.data.length <= 0 ? true : false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    goDetail(id) {
      if (this.studentInfo.avatar) {
        this.$router.push({
          path: "/classCourse",
          query: {
            id,
          },
        });
      } else {
        this.showTips = true;
      }
    },
    back(val) {
      this.activeIdx = val;
      this.$store.dispatch("getUserInfo");
    },
    onClickJoin() {
      if (this.studentInfo.avatar) {
        this.showCode = true;
      } else {
        this.showTips = true;
      }
    },
    // 加入班级
    handleJoin() {
      this.$loading.show();
      joinClass(this.classCode).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.getClassList();
          this.$message.success("加入成功");
        } else {
          this.$message.error(res.msg);
        }
      });
      this.showCode = false;
    },
    // 删除班级
    handleDel(classId) {
      this.$confirm(`确定要退出该班级吗？`, {
        type: "warning",
      }).then(() => {
        delClass(classId)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success("退出成功");
              this.getClassList();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      });
    },
    // 拖拽排序
    onDragStart(e) {
      e.target.classList.add("hideShadow");
    },
    onDragEnd(e) {
      e.target.classList.remove("hideShadow");
    },
    handleSort() {
      let arr = [];
      this.classList.forEach((item) => {
        arr.push(item.classId);
      });
      this.$loading.show();
      sortClass(arr).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sortClass = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  overflow: inherit;
  .info_box {
    width: 100%;

    .avatar {
      position: relative;
      display: inline-block;
      width: 240px;
      height: 240px;
      background: #d7d7d7;
      vertical-align: top;
      .img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
      }
    }

    .right {
      position: relative;
      display: inline-block;
      padding: 35px 70px;
      width: calc(100% - 240px);
      height: 240px;
      text-align: left;
      color: #fff;
      background: linear-gradient(180deg, #1976f5, #bd4593 100%);

      p {
        margin-bottom: 15px;

        &.name_row {
          padding-left: 35px;
          margin-bottom: 20px;

          span {
            font-size: 22px;
          }
        }

        .icon {
          margin-right: 19px;
          width: 18px;
          vertical-align: top;

          &.sex_icon {
            margin-left: 30px;
            width: 20px;
            vertical-align: -3px;
          }
        }
      }

      .set_btn {
        position: absolute;
        top: 34px;
        right: 20px;
        padding: 0;
        width: 120px;
        height: 35px;
        font-weight: bold;
        line-height: 35px;
        background: #ffffff;
        font-size: 18px;
        color: #1976f5;
        border-radius: 0;
      }

      .set_icon {
        position: absolute;
        right: 20px;
        bottom: 59px;
        width: 32px;
        cursor: pointer;
      }
    }
  }

  .main {
    position: relative;
    min-height: calc(100vh - 66px - 200px - 240px);

    .class_box {
      padding-top: 22px;
      padding-bottom: 15px;
      text-align: left;
      .title-row {
        margin-bottom: 18px;
        padding-left: 20px;
        height: 28px;
        line-height: 28px;
        border-left: 2px solid #1976f5;
        overflow: hidden;
        .title {
          float: left;
          line-height: 28px;
          text-align: left;
          font-size: 20px;
          font-weight: bold;
        }
      }

      // 拖拽
      .vue-draggable {
        &.hideShadow {
          .shadow {
            display: none;
          }
        }
      }

      .lesson {
        display: inline-block;
        margin-bottom: 16px;
        width: 227px;
        // border-radius: 10px;
        box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;

        &:not(:nth-child(5n)) {
          margin-right: 16px;
        }

        .cover_box {
          position: relative;
          width: 227px;
          height: 152px;
          overflow: hidden;
          cursor: pointer;

          &:hover {
            .cover {
              transform: scale(1.1, 1.1);
            }
            .mask {
              opacity: 1;
            }
          }

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            line-height: 152px;
            color: #fff;
            opacity: 0;
            font-size: 20px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            transition: opacity 0.3s;
            i {
              margin: 0 10px;
              cursor: pointer;
            }
          }
        }

        .cover {
          width: 100%;
          height: 100%;
          transition: all 0.5s ease;
        }

        .lesson_info {
          padding: 15px;

          .lesson_title,
          .class_name {
            max-width: 130px;
            color: #1976f5;
            font-size: 16px;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.class_name {
              font-size: 15px;
            }
          }

          .right_code {
            float: right;
            margin-top: 5px;

            p {
              text-align: center;
              font-size: 16px;

              &.code {
                color: #1976f5;
                font-weight: bold;
              }
            }
          }

          .counts {
            padding: 15px 10px 20px;

            .count_item {
              display: inline-block;
              margin: 0 5px;
              text-align: center;
              font-size: 14px;
              color: #000;
            }
          }

          .bottom {
            .btn {
              padding: 0;
              width: 100%;
              height: 36px;
              font-size: 16px;
              line-height: 36px;
              background: #1976f5;
            }
          }
        }
      }
    }
  }

  ::v-deep .code_dialog {
    .el-dialog {
      border-radius: 10px;

      .el-dialog__body {
        text-align: center;

        .logo {
          margin-bottom: 20px;
          width: 80px;
          height: 80px;
        }

        .tips {
          margin: 20px 0;
          font-size: 20px;
          color: #666;
          line-height: 1;
        }

        .input {
          width: 220px;
        }
      }

      .el-dialog__footer {
        padding-bottom: 40px;
        .btn {
          width: 82px;
          height: 40px;

          &.left {
            margin-right: 41px;
          }
        }
      }
    }
  }
}
</style>